// Borrowed some of this code from platform-library-nest
// The main logic was tested there. Added a few additional
// known field names to redact.

import stringify from 'json-stringify-safe';
import { find } from 'lodash';
import { DiagnosticFields } from '../../dto/diagnostics';
import { defaultProperties } from './redact.settings';

function isObject(property: any): boolean {
  return typeof property === 'object' && !Array.isArray(property);
}

// redacts a block of text revealing only specified chars from the left or right
function redactProp(text: string, left?: number, right?: number): any {
  if (typeof text !== 'string') return text;

  // Cut down abnormally large strings since we're redacting anyway
  const modifiedText =
    text.length > 99
      ? text.substring(0, 50) + text.substring(text.length - 50)
      : text;

  const start = Math.floor(left && left > -1 ? left : 0);
  const end = Math.floor(
    modifiedText.length - (start + (right && right > -1 ? right : 0))
  );
  const pattern = new RegExp(`(.{${start}}).{${end}}`, 'ism');

  return modifiedText.replace(pattern, '$1---');
}

// Recursively search through objects and arrays for properties and redacts their value
export const redact = (obj: DiagnosticFields): DiagnosticFields => {
  let redactMe: DiagnosticFields;

  if (!obj) {
    return obj;
  }

  try {
    redactMe = JSON.parse(stringify(obj));
  } catch (err) {
    console.error(err.message, err.stack);
    return obj;
  }

  Object.keys(redactMe).forEach(p => {
    if (typeof obj === 'undefined') {
      return obj;
    }

    if (typeof obj === 'string') {
      return redactProp(obj);
    }

    if (!isObject(obj) && !Array.isArray(obj)) {
      throw new TypeError('A valid JSON object must be specified');
    }

    const prop = find(defaultProperties, { prop: p });
    if (prop) {
      redactMe[p] = redactProp(redactMe[p], prop.leftPad, prop.rightPad);
    }

    if (Array.isArray(redactMe[p])) {
      redactMe[p].forEach((value, index) => {
        if (isObject(value)) {
          redactMe[p][index] = redact(value);
        }
      });
    } else if (isObject(redactMe[p])) {
      redactMe[p] = redact(redactMe[p]);
    }
  });

  return redactMe;
};
